import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { IconButtonProps } from '@mui/material/IconButton';

interface ExpandMoreProps extends IconButtonProps {
  readonly expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand: _expand, ...other } = props;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

interface Props {
  readonly expanded: boolean;
  readonly onExpandClick: () => void;
}

export const ExpandMoreCard = ({
  expanded,
  onExpandClick: handleExpandClick,
}: Readonly<Props>) => (
  <ExpandMore
    aria-expanded={expanded}
    aria-label="Plus d'informations"
    expand={expanded}
    onClick={handleExpandClick}
  >
    <ExpandMoreIcon />
  </ExpandMore>
);
